module.exports = __webpack_public_path__ + "themes/fq/sound/audio-sprite.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sound/audio-sprite.json
// module id = 23
// module chunks = d-game